import axiosInstance from "app/axios";
import { AxiosResponse } from "axios";
import { UserRoles } from "interfaces/UserRoles";

export interface BulkDeleteLotOffersInterface {
    ids: string[];
    endpoint?: UserRoles;
}

export interface BulkUpdateLotOffersResponseInterface {
  data: {
    
  };
}

export function fetchBulkDeleteLotOffers({ ids, endpoint = UserRoles.Admin }: BulkDeleteLotOffersInterface): Promise<AxiosResponse<BulkUpdateLotOffersResponseInterface, any>> {   
    return axiosInstance.delete(`${endpoint}/lot_offers/bulk_destroy`, {data: {ids}});
}
